import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPropRefundInvoicesList, exportPropRefundInvoices } from "../../Api/AdminApiCall";

export const fetchPropRefundInvoicesApi = createAsyncThunk(
    "admin/fetchPropRefundInvoicesApi",
    async ({ page = 1, pageSize = 10, paymentStatus = '', search = '' }, { rejectWithValue }) => {
        try {
            const res = await getPropRefundInvoicesList(page, pageSize, paymentStatus, search);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load refund invoices"
            );
        }
    }
);

export const exportPropRefundInvoicesApi = createAsyncThunk(
    "admin/exportPropRefundInvoicesApi",
    async ({ paymentStatus = '', search = '' }, { rejectWithValue }) => {
        try {
            const res = await exportPropRefundInvoices(paymentStatus, search);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to export refund invoices"
            );
        }
    }
);

const refundInvoiceSlice = createSlice({
    name: "refundInvoices",
    initialState: {
        listData: null,
        loading: false,
        error: null,
        exportLoading: false,
        exportError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPropRefundInvoicesApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPropRefundInvoicesApi.fulfilled, (state, action) => {
                state.loading = false;
                state.listData = action.payload;
            })
            .addCase(fetchPropRefundInvoicesApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(exportPropRefundInvoicesApi.pending, (state) => {
                state.exportLoading = true;
                state.exportError = null;
            })
            .addCase(exportPropRefundInvoicesApi.fulfilled, (state) => {
                state.exportLoading = false;
            })
            .addCase(exportPropRefundInvoicesApi.rejected, (state, action) => {
                state.exportLoading = false;
                state.exportError = action.payload;
            });
    },
});

export default refundInvoiceSlice.reducer;
